import { MunicipalNumberList } from 'civil-status/view-models/municipal-number';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<MunicipalNumberList, keyof MunicipalNumberList>[] = [
  {
    id: 'id',
    label: 'ID Richiesta',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'date',
    label: 'Data richiesta',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'number',
    label: 'Numero',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
